import { SelectionBase } from '../../state/selection/selection.state'

const to8bit = (n: number): number => {
    return Math.round(n * 255)
}

const toFloat = (n: number): number => {
    return n / Math.max(255, n)
}

const hexStringToUint24 = (color: string): number => {
    return parseInt(color.replace('#', ''), 16)
}

export const numberToHexString = (color: number): string => {
    return `#${color.toString(16).padStart(6, '0')}`
}

export const getColorForSelection = (selection: SelectionBase): number => {
    return selection.annotationVisible
        ? (hexStringToUint24(selection.annotationColor) << 8) + to8bit(selection.annotationOpacity)
        : 0
}

export const uint24ToRgbString = (uint: number): string => {
    return `rgb(${(uint & 0xff0000) >> 16}, ${(uint & 0xff00) >> 8}, ${uint & 0xff})`
}

export const rgbArrayToHexString = (color: Float32Array): string => {
    return numberToHexString((to8bit(color[0]) << 16) + (to8bit(color[1]) << 8) + to8bit(color[2]))
}

export const hexStringToRgbArray = (color: string): Float32Array => {
    const uint = hexStringToUint24(color)
    return new Float32Array([
        toFloat((uint & 0xff0000) >> 16),
        toFloat((uint & 0xff00) >> 8),
        toFloat(uint & 0xff),
    ])
}

export const hexStringToRgbString = (hexString: string): string => {
    const uint = hexStringToUint24(hexString)
    return `rgb(${(uint & 0xff0000) >> 16}, ${(uint & 0xff00) >> 8}, ${uint & 0xff})`
}

export const optionalRgbArrayToHexString = (color: Float32Array | undefined): string | null => {
    if (!color) return null
    return rgbArrayToHexString(color)
}

export const optionalHexStringToRgbArray = (color: string | null): Float32Array | undefined => {
    if (!color) return undefined
    return hexStringToRgbArray(color)
}

export const clamp01 = (value: number): number => Math.max(0, Math.min(1, value))
export const valueToPercent = (value: number): number => clamp01(value) * 100
export const percentToValue = (value: number): number => clamp01(value / 100)
